import { Gamepad2 } from "lucide-react";
import { EmptyState } from "@/components/ui/empty-state";

const EmptyGamesList = () => {
  return (
    <EmptyState
      icon={Gamepad2}
      title="No games found"
      description="Create your first game to start tracking birdies!"
    />
  );
};

export default EmptyGamesList;
